<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
        lg="9"
      >
        <v-card 
          flat 
          :class="[$vuetify.breakpoint.lgAndUp ? 'h-100' : '' ]"
        >
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                class="py-0"
              >
                <v-card flat>
                  <v-card-title>
                    <span class="subheading">
                      {{ item.tieu_de }}
                    </span>
                    <v-spacer/>
                    <span class="text-body-2 font-italic mr-4">
                      <v-icon small>mdi-clock</v-icon>
                      {{ item.published_at }}
                    </span>
                    <span class="text-body-2 font-italic mr-4">
                      <v-icon small>mdi-tag</v-icon>
                      {{ item.category ? item.category.dien_giai : 'notag' }}
                    </span>
                    <span class="text-body-2 font-italic">
                      <v-icon small>mdi-eye</v-icon>
                      {{ countView || 1 }}
                    </span>
                  </v-card-title>
                </v-card>
                <v-divider/>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <div v-html="item.mo_ta"/>
            <div class="post_content" v-html="item.noi_dung"/>
            <div v-if="item.attach_file">
              <h3 class="my-4">Văn bản đính kèm:</h3>
              <iframe 
                v-if="$vuetify.breakpoint.lgAndUp"
                class="embed-responsive-item" 
                :src="`${apiBaseUrl}/uploads/attach-file/${item.attach_file}`" 
                allowfullscreen 
                width="100%" 
                height="700px" 
                style="border: 0;"
              />
              <v-chip v-else>
                <a :href="`${apiBaseUrl}/uploads/attach-file/${item.attach_file}`">
                  {{ item.attach_file }}
                </a>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="4"
        lg="3"
      >
        <NewsRelated :currentId="String($route.params.id)"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import SystemSevice from '@/services/System';
  import NewsRelated from './NewsRelated.vue';
  import { mapState, mapActions } from 'vuex';
  export default {
    components: { 
      BaseBreadcrumbs,
      NewsRelated
    },
    data: () => ({
      crumbs: [],
      item: {},
      countView: 0,
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      "$route.params.id": function() {
        this.initialize();
      }
    },
    mounted() {
      if(this.$route.params.id){
        this.initialize();
      }
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      initialize(){
        SystemSevice.setSiteViewLocal({
          name: `NewsView@${this.$route.params.id}`,
        });
        this.viewCount();
        
        const app = this;
        app.getLoader(true);
        axios.get(`api/v1/public/news/${app.$route.params.id}`)
          .then(response => {
            app.item = response.data;
            app.crumbs = [
              {
                text: 'Trang chủ',
                disabled: false,
                href: '/',
              },
              {
                text: 'Tin nông nghiệp',
                disabled: false,
                href: '/news',
              }
            ];
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      viewCount(){
        axios.get(`api/v1/public/get-site-detail-counter/NewsView@${this.$route.params.id}`)
          .then(response => {
            this.countView=response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    }
  }
</script>
<style>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) !important;
  }
  .post_content .ql-align-justify{
    margin-bottom: 0;
  }
  .post_content .ql-align-center{
    text-align: center;
  }
  .post_content img {
    width: 70%;
  }
</style>